import {useContext} from 'react'
import {DataSourcesContext, IDataSourceItem} from '@/features/data-sources'
import './style.css'

export interface IMediaListStatsProps<T extends IDataSourceItem> {
  items: T[]
}

export function MediaListStats<T extends IDataSourceItem>(props: IMediaListStatsProps<T>) {
  const {items} = props

  const {mergedItems} = useContext(DataSourcesContext)

  return (
    <div className='media-list-stats'>
      <div
        className='bar'
        style={{
          width:
            mergedItems.length > 0 ? `${(items.length / mergedItems.length) * 100}%` : undefined,
        }}
      />
      {items.length} / {mergedItems.length}
    </div>
  )
}
